(function () {
  function removeGravityFonts() {
    document.querySelectorAll('style[data-description="gravity-font-faces"]').forEach(function (el) {
      el.remove();
    });
  }

  removeGravityFonts();

  var observer = new MutationObserver(function () {
    removeGravityFonts();
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();